import React from 'react';
import { NavLink } from 'react-router-dom';
import { Headset, School, Home, CalendarMonth, Chat, People } from '@mui/icons-material';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <ul className="nav nav-pills nav-justified">
                    <li className="nav-item">
                        <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/welfare-categories">
                            <span>
                                <Headset className="nav-icon" sx={{ fontSize: 24, mb: 0.5 }} />
                                <span className="nav-text">رفاهی-پشتیبانی</span>
                            </span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/events">
                            <span>
                                <CalendarMonth className="nav-icon" sx={{ fontSize: 24, mb: 0.5 }} />
                                <span className="nav-text">مراسمات</span>
                            </span>
                        </NavLink>
                    </li>
                    <li className="nav-item centerbutton">
                        <NavLink to="/" className="nav-link" id="centermenubtn">
                            <span className="theme-linear-gradient">
                                <Home sx={{ color: '#fff', fontSize: 26, transform: 'rotate(-45deg)' }} />
                            </span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/board-members">
                            <span>
                                <People className="nav-icon" sx={{ fontSize: 24, mb: 0.5 }} />
                                {/* <CalendarMonth  /> */}
                                <span className="nav-text">هیئت مدیره</span>
                            </span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/contact">
                            <span>
                                <Chat className="nav-icon" sx={{ fontSize: 24, mb: 0.5 }} />
                                <span className="nav-text">تماس</span>
                            </span>
                        </NavLink>
                    </li>
                </ul>
            </div>
        </footer>
    );
};

export default Footer;
